export default {
  /**
   * Recebe como parâmetros um tamanho em bytes, juntamente com a quantidade
   * de casas decimais desejada, e retorna o temanho formatado de modo
   * a facilitar a leitura
   * @param bytes tamanho em bytes
   * @param decimals quantidade de casas decimais
   * @return {String}
   */
  formatBytes: function (bytes, decimals) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const dm = decimals || 2
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  },
  /**
   * Recebe como parâmetro o mimetype de uma mídia/arquivo e analiza
   * se é uma imagem
   * @param mimetype
   */
  isNotImage: function (mimetype) {
    const array = mimetype.split('/')
    return array[0] !== 'image'
  },
  /**
   * Recebe como parâmetro um mimetype de uma mídia, e retorna
   * o ícone apropriado
   * @param fileType mimetype da mídia
   * @returns {icon} ícone a ser apresentado
   */
  getMediaIcon: function (fileType) {
    // Quebra o mimetype em duas partes para avaliação
    const split = fileType.split('/')
    let icon = ''

    // Avalia o mimetype e retorna o devido ícone
    if (split[1].search('pdf') >= 0) {
      icon = 'mdi-file-pdf-outline'
    } else if (split[0].search('image') >= 0) {
      icon = 'mdi-file-image-outline'
    } else if (split[1].search('word') >= 0) {
      icon = 'mdi-file-word-outline'
    } else if (split[1].search('html') >= 0) {
      icon = 'mdi-language-html5'
    } else if (split[1].search('css') >= 0) {
      icon = 'mdi-language-css3'
    } else if (split[1].search('excel') >= 0) {
      icon = 'mdi-file-excel-outline'
    } else if (split[0].search('audio') >= 0) {
      icon = 'mdi-file-music-outline'
    } else if (split[0].search('text') >= 0) {
      icon = 'mdi-file-document-outline'
    } else {
      icon = 'mdi-file-outline'
    }

    return icon
  },
  /**
   * Permite gravar uma faixa de áudio pelo navegador
   */
  recordAudio: function () {
    let start, stop, stream, audioTracker, mediaRecorder, audioChunks

    // eslint-disable-next-line prefer-const
    start = async function () {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      } catch (e) {
        this.$toasted.global.error({ message: 'É necessário permitir o uso do microfone para gravar áudios' })
      }

      audioTracker = stream.getAudioTracks()[0]
      mediaRecorder = new MediaRecorder(stream)
      audioChunks = []
      mediaRecorder.start()
      mediaRecorder.addEventListener('dataavailable', event => {
        audioChunks.push(event.data)
      })
    }

    // eslint-disable-next-line prefer-const
    stop = function () {
      return new Promise(resolve => {
        mediaRecorder.addEventListener('stop', (e) => {
          const audioFile = new Blob(audioChunks, { type: 'audio/mp3' })
          const reader = new FileReader()
          reader.readAsDataURL(audioFile)
          reader.onloadend = function (event) {
            const audioPlayer = new Audio(event.target.result)
            resolve({ audioFile, audioPlayer })
          }
          audioTracker.stop()
        })
        mediaRecorder.stop()
      })
    }

    return { start, stop }
  }
}
